import React from "react";
import Box from "../boxes/Box";
import SliderField from "../form-fields/SliderField";
import SliderWithButtonsField from "../form-fields/SliderWithButtonsField";
import { formatCurrency } from "../../utils/formats";
import { t } from "../../i18n";

const PeriodLabel = ({ i18nKey, number }: { i18nKey: string, number: number }) => (
  <>
    <span className="font-bold text-3xl">{number}</span>&nbsp;
    {t(i18nKey, { count: number })}
  </>
);

const formatLoanPeriods = (months: number): React.ReactNode => {
  const yearsCount = Math.floor(months / 12);
  const monthsCount = months % 12;

  if (yearsCount === 0) {
    return <PeriodLabel i18nKey="short_months" number={monthsCount}/>
  } else if (monthsCount === 0) {
    return <PeriodLabel i18nKey="short_years" number={yearsCount}/>
  } else {
    return (
      <>
        <PeriodLabel i18nKey="short_years" number={yearsCount}/>&nbsp;
        <PeriodLabel i18nKey="short_months" number={monthsCount}/>
      </>
    )
  }
};

interface Props {
  amountStep: number;
  maxAmount: number;
  maxPeriod: number;
  minAmount: number;
  minPeriod: number;
  periodStep: number;
}

const AmountAndPeriodFields = (props: Props): JSX.Element => {
  const { amountStep, maxAmount, maxPeriod, minAmount, minPeriod, periodStep } = props;
  const maxPeriodInYears = Math.floor(maxPeriod / 12);

  return (
    <>
      <Box className="mt-8" maxWidth="480px">
        <SliderField
          id="field_amount"
          mainLabel={t("amount")}
          max={maxAmount}
          min={minAmount}
          name="amount"
          showCurrentValue
          showMinMaxLabels
          step={amountStep}
          valueToString={formatCurrency}
        />
        <SliderWithButtonsField
          className="mt-8"
          id="field_period"
          mainLabel={t("period")}
          max={maxPeriod}
          maxLabel={`${maxPeriodInYears} ${t("short_years", { count: maxPeriodInYears })}`}
          min={minPeriod}
          minLabel={`${minPeriod} ${t("short_months", { count: minPeriod })}`}
          name="period"
          showCurrentValue
          showMinMaxLabels
          step={periodStep}
          valueToString={formatLoanPeriods}
        />
      </Box>
    </>
  );
};

export default AmountAndPeriodFields;
